// Comprehensive Mock Data for Alden Technologies Website

// ========================================
// WATER FILLING MACHINES DATA
// ========================================

export const waterFillingMachines = [
  {
    id: 'wfm-30',
    capacity: '30 BPM',
    title: '30 BPM Water Filling Machine',
    slug: '30-bpm-water-filling-machine',
    metaTitle: '30 BPM Water Filling Machine | Alden Technologies',
    metaDescription: 'High-quality 30 BPM water filling machine for small-scale mineral water bottling plants. Ideal for startups with semi-automatic operation.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹8-12 Lakhs',
      investment: 'Low Investment'
    },
    specifications: {
      capacity: '30 Bottles Per Minute (1800 BPH)',
      fillingHeads: '6 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 304 Food Grade',
      power: '2 HP / Single Phase',
      automation: 'Semi-Automatic',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      'Food-grade stainless steel construction',
      'Automatic bottle feeding system',
      'No bottle, no fill mechanism',
      'Adjustable filling volume',
      'Drip-proof filling nozzles',
      'Easy maintenance design',
      'Low power consumption',
      'Compact footprint'
    ],
    applications: [
      'Packaged Drinking Water',
      'Mineral Water Bottling',
      'Small-scale Water Plants',
      'Startup Bottling Units'
    ],
    idealFor: 'Startups and small-scale water bottling businesses looking for reliable, low-investment filling solutions.',
    technicalDetails: {
      dimensions: '1800 x 900 x 1800 mm',
      weight: '350 kg',
      voltage: '220V / 50Hz',
      warranty: '1 Year Comprehensive'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'wfm-40',
    capacity: '40 BPM',
    title: '40 BPM Water Filling Machine',
    slug: '40-bpm-water-filling-machine',
    metaTitle: '40 BPM Water Filling Machine | Alden Technologies',
    metaDescription: 'Advanced 40 BPM water filling machine with 8 filling heads. Perfect for medium-scale mineral water production with automatic operations.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹12-16 Lakhs',
      investment: 'Medium Investment'
    },
    specifications: {
      capacity: '40 Bottles Per Minute (2400 BPH)',
      fillingHeads: '8 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 304 Food Grade',
      power: '3 HP / Three Phase',
      automation: 'Automatic',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      'Fully automatic operation',
      '8-head rotary filling system',
      'PLC-based control panel',
      'High-speed production',
      'Servo motor driven',
      'Self-lubricating system',
      'Touch screen HMI',
      'Production counter'
    ],
    applications: [
      'Medium-scale Water Plants',
      'Commercial Bottling',
      'Packaged Drinking Water',
      'Mineral Water Production'
    ],
    idealFor: 'Growing businesses requiring higher production capacity with automated operations and consistent quality.',
    technicalDetails: {
      dimensions: '2200 x 1200 x 2000 mm',
      weight: '550 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year Comprehensive'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'wfm-60',
    capacity: '60 BPM',
    title: '60 BPM Water Filling Machine',
    slug: '60-bpm-water-filling-machine',
    metaTitle: '60 BPM Water Filling Machine | Alden Technologies',
    metaDescription: 'High-speed 60 BPM automatic water filling machine with 12 heads. Ideal for commercial-scale mineral water bottling operations.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹18-25 Lakhs',
      investment: 'Medium-High Investment'
    },
    specifications: {
      capacity: '60 Bottles Per Minute (3600 BPH)',
      fillingHeads: '12 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 304/316 Food Grade',
      power: '5 HP / Three Phase',
      automation: 'Fully Automatic',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      '12-head rotary filling system',
      'Advanced PLC automation',
      'Servo-driven precision',
      'Auto bottle orientation',
      'Integrated rinsing system',
      'Touch screen control',
      'Remote diagnostics ready',
      'Energy-efficient operation'
    ],
    applications: [
      'Commercial Water Bottling',
      'Large-scale Production',
      'Industrial Bottling Plants',
      'Contract Manufacturing'
    ],
    idealFor: 'Established businesses requiring high-speed production with maximum automation and minimal manual intervention.',
    technicalDetails: {
      dimensions: '2800 x 1500 x 2200 mm',
      weight: '850 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year Comprehensive + AMC Available'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'wfm-90',
    capacity: '90 BPM',
    title: '90 BPM Water Filling Machine',
    slug: '90-bpm-water-filling-machine',
    metaTitle: '90 BPM Water Filling Machine | Alden Technologies',
    metaDescription: 'Industrial-grade 90 BPM automatic water filling machine. High-speed production for large-scale mineral water bottling plants.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹28-38 Lakhs',
      investment: 'High Investment'
    },
    specifications: {
      capacity: '90 Bottles Per Minute (5400 BPH)',
      fillingHeads: '18 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 316 Food Grade',
      power: '7.5 HP / Three Phase',
      automation: 'Fully Automatic with PLC',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      '18-head high-speed rotary system',
      'Siemens PLC control',
      'Servo motor precision',
      'Integrated rinse-fill-cap line',
      'Auto rejection system',
      'SCADA monitoring ready',
      '24/7 production capability',
      'Low maintenance design'
    ],
    applications: [
      'Large-scale Industrial Plants',
      'High-volume Production',
      'Export-oriented Units',
      'Multi-shift Operations'
    ],
    idealFor: 'Large-scale manufacturers requiring industrial-grade equipment for 24/7 high-volume production operations.',
    technicalDetails: {
      dimensions: '3500 x 2000 x 2400 mm',
      weight: '1350 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year + 2 Years AMC Included'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'wfm-120',
    capacity: '120 BPM',
    title: '120 BPM Water Filling Machine',
    slug: '120-bpm-water-filling-machine',
    metaTitle: '120 BPM Water Filling Machine | Alden Technologies',
    metaDescription: 'Ultra-high-speed 120 BPM water filling machine with 24 heads. Premium solution for large-scale industrial bottling operations.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹45-60 Lakhs',
      investment: 'Premium Investment'
    },
    specifications: {
      capacity: '120 Bottles Per Minute (7200 BPH)',
      fillingHeads: '24 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 316L Food Grade',
      power: '10 HP / Three Phase',
      automation: 'Industry 4.0 Ready',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      '24-head ultra-high-speed system',
      'Siemens S7 PLC with HMI',
      'IoT-enabled monitoring',
      'Predictive maintenance alerts',
      'Integrated quality control',
      'Remote diagnostics',
      'Energy recovery system',
      'Minimal changeover time'
    ],
    applications: [
      'Industrial-scale Production',
      'Export Manufacturing',
      'Contract Bottling',
      'Multi-brand Operations'
    ],
    idealFor: 'Industry leaders requiring cutting-edge technology for maximum production capacity with smart monitoring.',
    technicalDetails: {
      dimensions: '4500 x 2500 x 2600 mm',
      weight: '2100 kg',
      voltage: '380V / 50Hz',
      warranty: '2 Years Comprehensive + 3 Years AMC'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'wfm-200',
    capacity: '200 BPM',
    title: '200 BPM Water Filling Machine',
    slug: '200-bpm-water-filling-machine',
    metaTitle: '200 BPM Water Filling Machine | Enterprise Solution | Alden Technologies',
    metaDescription: 'Enterprise-grade 200 BPM water filling machine with 40 heads. Maximum production capacity for mega industrial bottling plants.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    price: {
      range: '₹80 Lakhs - 1.2 Crores',
      investment: 'Enterprise Investment'
    },
    specifications: {
      capacity: '200 Bottles Per Minute (12000 BPH)',
      fillingHeads: '40 Heads',
      bottleSize: '200ml to 2000ml',
      material: 'SS 316L Food Grade',
      power: '15 HP / Three Phase',
      automation: 'Full Industry 4.0 Integration',
      airPressure: '6-8 kg/cm²'
    },
    features: [
      '40-head mega production system',
      'Siemens S7-1500 PLC',
      'Full IoT integration',
      'AI-powered quality inspection',
      'Blockchain-ready traceability',
      'Cloud-based analytics',
      'Zero-downtime architecture',
      'Modular scalable design'
    ],
    applications: [
      'Mega Industrial Plants',
      'National Brand Manufacturing',
      'International Export Units',
      'Ultra-high-volume Production'
    ],
    idealFor: 'Enterprise-level manufacturers requiring maximum production capacity with cutting-edge Industry 4.0 capabilities.',
    technicalDetails: {
      dimensions: '6000 x 3500 x 3000 mm',
      weight: '3500 kg',
      voltage: '380V / 50Hz',
      warranty: '3 Years Comprehensive + 5 Years AMC'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  }
];

// ========================================
// RO PLANTS DATA
// ========================================

export const roPlants = [
  {
    id: 'ro-2000',
    capacity: '2000 LPH',
    title: '2000 LPH RO Plant',
    slug: '2000-lph-ro-plant',
    metaTitle: '2000 LPH RO Water Plant | Alden Technologies',
    metaDescription: 'Commercial 2000 LPH RO plant for small-scale water purification. Ideal for startups and local water supply businesses.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    price: {
      range: '₹3-5 Lakhs',
      investment: 'Low Investment'
    },
    specifications: {
      capacity: '2000 Liters Per Hour',
      membraneType: 'Dow Filmtec / Hydranautics',
      stages: '5-Stage Purification',
      recoveryRate: '40-50%',
      tds: 'Input: Up to 2000 ppm',
      powerConsumption: '3 kW',
      automation: 'Semi-Automatic'
    },
    features: [
      '5-stage RO purification',
      'UV and Ozone disinfection',
      'Pre and post carbon filters',
      'Auto flush system',
      'TDS controller',
      'Pressure gauge monitoring',
      'Food-grade FRP housing',
      'Low maintenance'
    ],
    applications: [
      'Small Bottling Plants',
      'Restaurants and Hotels',
      'Community Water Supply',
      'Packaged Water Startups'
    ],
    idealFor: 'Small businesses and startups looking for reliable water purification for low to medium production volumes.',
    technicalDetails: {
      dimensions: '1500 x 800 x 1800 mm',
      weight: '250 kg',
      voltage: '220V / 50Hz',
      warranty: '1 Year on Parts'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'ro-3000',
    capacity: '3000 LPH',
    title: '3000 LPH RO Plant',
    slug: '3000-lph-ro-plant',
    metaTitle: '3000 LPH RO Water Plant | Alden Technologies',
    metaDescription: 'Industrial 3000 LPH RO plant with advanced filtration. Perfect for medium-scale commercial water production.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    price: {
      range: '₹5-7 Lakhs',
      investment: 'Medium Investment'
    },
    specifications: {
      capacity: '3000 Liters Per Hour',
      membraneType: 'Dow Filmtec',
      stages: '6-Stage Purification',
      recoveryRate: '50-60%',
      tds: 'Input: Up to 2500 ppm',
      powerConsumption: '4.5 kW',
      automation: 'Automatic'
    },
    features: [
      '6-stage advanced purification',
      'Dual UV sterilization',
      'Ozonation system',
      'Auto backwash',
      'Digital TDS monitor',
      'PLC-based control',
      'SS 304 framework',
      'Energy-efficient pumps'
    ],
    applications: [
      'Medium Bottling Plants',
      'Industrial Water Supply',
      'Hospitals and Institutions',
      'Commercial Production'
    ],
    idealFor: 'Growing businesses requiring consistent high-quality water production with minimal operator intervention.',
    technicalDetails: {
      dimensions: '1800 x 1000 x 2000 mm',
      weight: '400 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year Comprehensive'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'ro-4000',
    capacity: '4000 LPH',
    title: '4000 LPH RO Plant',
    slug: '4000-lph-ro-plant',
    metaTitle: '4000 LPH RO Water Plant | Alden Technologies',
    metaDescription: 'High-capacity 4000 LPH RO plant with multi-stage filtration. Ideal for commercial-scale water bottling operations.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    price: {
      range: '₹7-10 Lakhs',
      investment: 'Medium-High Investment'
    },
    specifications: {
      capacity: '4000 Liters Per Hour',
      membraneType: 'Dow Filmtec / CSM',
      stages: '7-Stage Purification',
      recoveryRate: '55-65%',
      tds: 'Input: Up to 3000 ppm',
      powerConsumption: '6 kW',
      automation: 'Fully Automatic'
    },
    features: [
      '7-stage comprehensive purification',
      'Triple UV protection',
      'Advanced ozonation',
      'Auto cleaning cycle',
      'Online TDS monitoring',
      'Touch screen HMI',
      'SS 316 construction',
      'Remote monitoring ready'
    ],
    applications: [
      'Large Bottling Operations',
      'Industrial Manufacturing',
      'Pharmaceutical Grade Water',
      'Food Processing Units'
    ],
    idealFor: 'Established businesses requiring pharmaceutical-grade water quality with high production capacity.',
    technicalDetails: {
      dimensions: '2200 x 1200 x 2200 mm',
      weight: '600 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year + AMC Available'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'ro-5000',
    capacity: '5000 LPH',
    title: '5000 LPH RO Plant',
    slug: '5000-lph-ro-plant',
    metaTitle: '5000 LPH RO Water Plant | Alden Technologies',
    metaDescription: 'Industrial-grade 5000 LPH RO plant with advanced automation. Perfect for high-volume water production.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    price: {
      range: '₹10-14 Lakhs',
      investment: 'High Investment'
    },
    specifications: {
      capacity: '5000 Liters Per Hour',
      membraneType: 'Dow Filmtec Premium',
      stages: '8-Stage Purification',
      recoveryRate: '60-70%',
      tds: 'Input: Up to 3500 ppm',
      powerConsumption: '7.5 kW',
      automation: 'Industry 4.0 Ready'
    },
    features: [
      '8-stage industrial purification',
      'Quad UV sterilization',
      'Advanced oxidation process',
      'Intelligent auto-flush',
      'Real-time quality monitoring',
      'PLC with SCADA',
      'Energy recovery system',
      'Predictive maintenance'
    ],
    applications: [
      'Large-scale Industrial Plants',
      'Pharmaceutical Manufacturing',
      'Beverage Production',
      'Export-quality Production'
    ],
    idealFor: 'Large manufacturers requiring pharmaceutical-grade water with maximum efficiency and automation.',
    technicalDetails: {
      dimensions: '2800 x 1500 x 2500 mm',
      weight: '950 kg',
      voltage: '380V / 50Hz',
      warranty: '2 Years + 2 Years AMC'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'ro-10000',
    capacity: '10000 LPH',
    title: '10000 LPH RO Plant',
    slug: '10000-lph-ro-plant',
    metaTitle: '10000 LPH RO Water Plant | Enterprise Solution | Alden Technologies',
    metaDescription: 'Enterprise-grade 10000 LPH RO plant with IoT integration. Maximum capacity for mega industrial water production.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    price: {
      range: '₹18-28 Lakhs',
      investment: 'Enterprise Investment'
    },
    specifications: {
      capacity: '10000 Liters Per Hour',
      membraneType: 'Dow Filmtec Ultra Premium',
      stages: '10-Stage Purification',
      recoveryRate: '70-75%',
      tds: 'Input: Up to 4000 ppm',
      powerConsumption: '12 kW',
      automation: 'Full Industry 4.0 Integration'
    },
    features: [
      '10-stage mega purification',
      'Multi-barrier UV protection',
      'Nano-filtration option',
      'AI-powered auto optimization',
      'IoT cloud monitoring',
      'Blockchain water traceability',
      'Zero liquid discharge ready',
      'Solar integration option'
    ],
    applications: [
      'Mega Industrial Plants',
      'Multi-location Operations',
      'National Brand Production',
      'International Export Units'
    ],
    idealFor: 'Enterprise manufacturers requiring maximum production capacity with cutting-edge automation and sustainability.',
    technicalDetails: {
      dimensions: '4000 x 2000 x 3000 mm',
      weight: '1800 kg',
      voltage: '380V / 50Hz',
      warranty: '3 Years Comprehensive + 5 Years AMC'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
      'https://images.unsplash.com/photo-1580489944761-15a19d654956',
      'https://images.unsplash.com/photo-1563453392212-326f5e854473'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  }
];

// ========================================
// AUXILIARY MACHINES DATA
// ========================================

export const auxiliaryMachines = [
  {
    id: 'pet-blowing',
    title: 'PET Bottle Blowing Machine',
    slug: 'pet-bottle-blowing-machine',
    metaTitle: 'PET Bottle Blowing Machine | Alden Technologies',
    metaDescription: 'Advanced PET bottle blowing machine for manufacturing custom plastic bottles. Semi-automatic and fully automatic models available.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/57f529b3089387bd7073555b73c6090bd4ab619173190c8346f2f661b66d40a2.jpeg',
    price: {
      range: '₹5-15 Lakhs',
      investment: 'Medium Investment'
    },
    specifications: {
      capacity: '500-2000 BPH',
      bottleVolume: '100ml to 2000ml',
      cavities: '2/4/6 Cavity Options',
      material: 'PET Preform',
      powerConsumption: '15 kW',
      automation: 'Semi-Auto / Fully Auto',
      airPressure: '25-30 bar'
    },
    features: [
      'Energy-efficient heating system',
      'Precision mold temperature control',
      'Quick mold changeover',
      'Auto preform loading (Fully Auto)',
      'PLC-based control',
      'Touch screen operation',
      'Low rejection rate',
      'Multiple bottle shape capability'
    ],
    applications: [
      'Mineral Water Bottles',
      'Juice Bottles',
      'CSD Bottles',
      'Edible Oil Bottles'
    ],
    idealFor: 'Bottling plants looking to manufacture custom bottles in-house and reduce dependency on external bottle suppliers.',
    technicalDetails: {
      dimensions: '2500 x 1200 x 2000 mm',
      weight: '1200 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year + Spare Parts Support'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/57f529b3089387bd7073555b73c6090bd4ab619173190c8346f2f661b66d40a2.jpeg',
      'https://images.unsplash.com/photo-1581093588401-fbb62a02f120',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/fee152e3e8af8f2f2db9442eb1155451bdd1947137f5ca671d324b946f16f322.jpeg'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'sticker-labelling',
    title: 'Sticker Labelling Machine',
    slug: 'sticker-labelling-machine',
    metaTitle: 'Sticker Labelling Machine | Alden Technologies',
    metaDescription: 'High-speed automatic sticker labelling machine for bottles. Front, back, and wrap-around labelling options available.',
    heroImage: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
    price: {
      range: '₹3-8 Lakhs',
      investment: 'Low-Medium Investment'
    },
    specifications: {
      capacity: '30-120 BPM',
      labelType: 'Self-adhesive Sticker',
      bottleSize: '100ml to 2000ml',
      labelWidth: '20mm to 150mm',
      powerConsumption: '2 kW',
      automation: 'Automatic',
      accuracy: '±1mm'
    },
    features: [
      'High-speed automatic operation',
      'Front and back labelling',
      'Wrap-around option available',
      'Bottle orientation system',
      'No bottle, no label function',
      'Label shortage alarm',
      'Servo motor driven',
      'Easy label roll loading'
    ],
    applications: [
      'Water Bottle Labelling',
      'Juice Bottle Labelling',
      'CSD Bottle Labelling',
      'Oil Bottle Labelling'
    ],
    idealFor: 'Bottling plants requiring professional, consistent, and high-speed labelling for branding and compliance.',
    technicalDetails: {
      dimensions: '2000 x 1000 x 1500 mm',
      weight: '400 kg',
      voltage: '220V / 50Hz',
      warranty: '1 Year on Machine'
    },
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  },
  {
    id: 'shrink-packaging',
    title: 'Shrink Packaging Machine',
    slug: 'shrink-packaging-machine',
    metaTitle: 'Shrink Packaging Machine | Alden Technologies',
    metaDescription: 'Automatic shrink wrapping machine for bottle packing. Complete solution for secondary packaging with shrink tunnel.',
    heroImage: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d',
    price: {
      range: '₹4-10 Lakhs',
      investment: 'Medium Investment'
    },
    specifications: {
      capacity: '20-100 Packs/Min',
      packSize: '6/12/24 Bottles Per Pack',
      filmType: 'LDPE Shrink Film',
      tunnelLength: '1500mm to 3000mm',
      powerConsumption: '18 kW',
      automation: 'Semi-Auto / Fully Auto',
      sealingType: 'L-Bar Sealing'
    },
    features: [
      'Automatic bottle grouping',
      'Precise film cutting and sealing',
      'Temperature-controlled tunnel',
      'Variable pack size options',
      'Quick changeover',
      'Film roll tension control',
      'Energy-efficient heating',
      'Compact design'
    ],
    applications: [
      'Water Bottle Packing',
      'Multi-pack Beverage Packaging',
      'Bulk Transportation Packing',
      'Retail Ready Packaging'
    ],
    idealFor: 'Bottling plants looking for professional secondary packaging to improve logistics efficiency and product presentation.',
    technicalDetails: {
      dimensions: '4000 x 1200 x 1600 mm',
      weight: '800 kg',
      voltage: '380V / 50Hz',
      warranty: '1 Year + Spares Available'
    },
    gallery: [
      'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg'
    ],
    brochureUrl: '/downloads/alden-product-brochure.pdf'
  }
];

// ========================================
// MANUFACTURING PROCESS DATA
// ========================================

export const manufacturingProcess = [
  {
    id: 'ss-fabrication',
    title: 'SS Frame Fabrication',
    description: 'Precision stainless steel frame fabrication using SS 304/316 food-grade material for machine structural integrity.',
    icon: 'wrench',
    image: 'https://images.unsplash.com/photo-1504917595217-d4dc5ebe6122',
    details: 'Our fabrication facility uses premium-grade stainless steel with TIG welding for food-grade compliance and long-term durability.'
  },
  {
    id: 'laser-cutting',
    title: 'Laser Cutting',
    description: 'CNC laser cutting technology for precise component manufacturing with accuracy up to 0.1mm tolerance.',
    icon: 'scissors',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837',
    details: 'State-of-the-art fiber laser cutting machines ensure precise cuts for all metal components with minimal material wastage.'
  },
  {
    id: 'argon-welding',
    title: 'Argon Welding',
    description: 'Advanced TIG welding with argon gas shielding for high-quality, contamination-free weld joints.',
    icon: 'flame',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837',
    details: 'Certified welders perform argon TIG welding ensuring food-grade compliance and leak-proof construction.'
  },
  {
    id: 'machining',
    title: 'Machining',
    description: 'Precision CNC machining for manufacturing critical components like filling nozzles, valves, and shafts.',
    icon: 'cpu',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
    details: 'In-house CNC machining center with 5-axis capability for manufacturing high-precision components.'
  },
  {
    id: 'assembly',
    title: 'Assembly',
    description: 'Expert assembly of machines with quality checks at each stage ensuring zero-defect production.',
    icon: 'package',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    details: 'Skilled technicians assemble machines following documented SOPs with stage-wise quality inspections.'
  },
  {
    id: 'plc-wiring',
    title: 'PLC & HMI Wiring',
    description: 'Complete electrical wiring with PLC programming and HMI configuration for automated machine control.',
    icon: 'monitor',
    image: 'https://images.unsplash.com/photo-1558346490-a72e53ae2d4f',
    details: 'Certified electrical engineers handle PLC programming (Siemens/Allen Bradley) and panel wiring with industrial standards.'
  },
  {
    id: 'testing',
    title: 'Machine Testing',
    description: 'Rigorous testing of machines with water trials, load testing, and performance validation before dispatch.',
    icon: 'checkCircle',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    details: 'Every machine undergoes 72-hour continuous testing with actual production trials to validate performance.'
  },
  {
    id: 'quality-inspection',
    title: 'Quality Inspection',
    description: 'Multi-point quality inspection checklist covering mechanical, electrical, and functional parameters.',
    icon: 'shield',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837',
    details: 'Independent quality control team performs final inspection against 150+ checkpoint quality audit before clearance.'
  },
  {
    id: 'dispatch',
    title: 'Dispatch',
    description: 'Safe packaging and timely dispatch with documentation including manuals, drawings, and compliance certificates.',
    icon: 'truck',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d',
    details: 'Professional export-grade packaging ensures safe transportation. Complete documentation provided for customs and operations.'
  }
];

// ========================================
// INSTALLATION GALLERY DATA
// ========================================

export const installationGallery = [
  {
    id: 'rajasthan-1',
    state: 'Rajasthan',
    city: 'Jaipur',
    client: 'Rajasthan Pure Water Pvt Ltd',
    capacity: '6000 BPH (60 BPM)',
    year: '2024',
    description: 'Complete turnkey mineral water plant with 60 BPM filling machine, 4000 LPH RO plant, and shrink packaging line.',
    image: 'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
    gallery: [
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg'
    ],
  },
  {
    id: 'gujarat-1',
    state: 'Gujarat',
    city: 'Ahmedabad',
    client: 'Gujarat Hydro Industries',
    capacity: '12000 BPH (120 BPM)',
    year: '2024',
    description: 'Large-scale water bottling plant with 120 BPM automatic filling machine and 10000 LPH RO system.',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
  },
  {
    id: 'bihar-1',
    state: 'Bihar',
    city: 'Patna',
    client: 'Bihar Fresh Waters',
    capacity: '3600 BPH (40 BPM)',
    year: '2023',
    description: 'Medium-scale packaged drinking water plant with 40 BPM machine and 3000 LPH RO plant.',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
  },
  {
    id: 'up-1',
    state: 'Uttar Pradesh',
    city: 'Noida',
    client: 'UP Aqua Solutions',
    capacity: '9000 BPH (90 BPM)',
    year: '2024',
    description: 'Industrial-grade mineral water plant with 90 BPM filling line, 5000 LPH RO plant, and complete automation.',
    image: 'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
    gallery: [
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg'
    ],
  },
  {
    id: 'haryana-1',
    state: 'Haryana',
    city: 'Gurgaon',
    client: 'Haryana Crystal Waters',
    capacity: '7200 BPH (120 BPM)',
    year: '2024',
    description: 'High-capacity bottling plant with 120 BPM machine, PET blowing unit, and automated packaging line.',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
  },
  {
    id: 'punjab-1',
    state: 'Punjab',
    city: 'Ludhiana',
    client: 'Punjab Pure Drinks',
    capacity: '4800 BPH (60 BPM)',
    year: '2023',
    description: 'Complete turnkey project with 60 BPM filling machine, 4000 LPH RO plant, and labelling system.',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
    gallery: [
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258'
    ],
  },
  {
    id: 'delhi-1',
    state: 'Delhi NCR',
    city: 'Delhi',
    client: 'Delhi Metro Waters',
    capacity: '10000 BPH (120 BPM)',
    year: '2024',
    description: 'Premium turnkey plant with 120 BPM automatic machine, 10000 LPH RO system, and IoT monitoring.',
    image: 'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
    gallery: [
      'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
      'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/dbde2cca544a6c11e7bd1116760c2ac46cfbe90f3366f651e1e1999e9b1c409f.jpeg'
    ],
  }
];

// ========================================
// HOMEPAGE STATS DATA (Updated for Premium Positioning)
// ========================================

export const stats = [
  { 
    id: "projects", 
    label: "Projects Completed", 
    value: "100+", 
    icon: "factory",
    color: "alden-green" 
  },
  { 
    id: "capacity", 
    label: "Production Capacity", 
    value: "30-200 BPM", 
    icon: "package",
    color: "alden-green" 
  },
  { 
    id: "ro-capacity", 
    label: "RO Plant Capacity", 
    value: "2000-10000 LPH", 
    icon: "droplet",
    color: "alden-green" 
  },
  { 
    id: "presence", 
    label: "Pan India Presence", 
    value: "15+ States", 
    icon: "globe",
    color: "alden-green" 
  }
];

// ========================================
// BLOG ARTICLES METADATA
// ========================================

export const blogArticles = [
  {
    id: 'mineral-water-plant-cost',
    slug: 'mineral-water-plant-cost-india',
    title: 'Mineral Water Plant Cost in India 2025',
    metaTitle: 'Mineral Water Plant Cost in India 2025 | Complete Investment Guide',
    metaDescription: 'Complete breakdown of mineral water plant setup cost in India. Know investment required for 20 BPM to 200 BPM capacity plants with machinery, licensing, and operational costs.',
    category: 'Investment Guide',
    author: 'Alden Technologies',
    publishDate: '2025-01-15',
    readTime: '8 min read',
    image: 'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
    excerpt: 'Complete investment guide for setting up a mineral water bottling plant in India. From machinery costs to licensing fees, understand the complete budget breakdown.',
    featured: true
  },
  {
    id: 'start-mineral-water-business',
    slug: 'how-to-start-mineral-water-plant-business',
    title: 'How to Start a Mineral Water Plant Business in India',
    metaTitle: 'How to Start Mineral Water Plant Business in India 2025 | Step-by-Step Guide',
    metaDescription: 'Complete guide on starting a profitable mineral water bottling business in India. Learn about licenses, machinery, setup costs, marketing, and profitability.',
    category: 'Business Guide',
    author: 'Alden Technologies',
    publishDate: '2025-01-10',
    readTime: '10 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    excerpt: 'Step-by-step guide to starting your mineral water bottling business. From market research to plant commissioning, learn everything you need to succeed.',
    featured: true
  },
  {
    id: 'bis-certification',
    slug: 'bis-certification-packaged-drinking-water',
    title: 'BIS Certification for Packaged Drinking Water',
    metaTitle: 'BIS Certification for Packaged Drinking Water | Complete Guide 2025',
    metaDescription: 'Complete guide on obtaining BIS certification (IS 14543) for packaged drinking water. Requirements, process, documentation, fees, and timeline explained.',
    category: 'Compliance',
    author: 'Alden Technologies',
    publishDate: '2025-01-08',
    readTime: '7 min read',
    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85',
    excerpt: 'BIS certification is mandatory for selling packaged drinking water in India. Understand the complete process, requirements, and how to obtain IS 14543 certification.',
    featured: false
  },
  {
    id: 'fssai-license',
    slug: 'fssai-licence-mineral-water-plant',
    title: 'FSSAI Licence for Mineral Water Plant',
    metaTitle: 'FSSAI License for Mineral Water Plant | Registration Process 2025',
    metaDescription: 'Complete guide on obtaining FSSAI license for mineral water bottling plant. Know the types, documentation, fees, and registration process.',
    category: 'Compliance',
    author: 'Alden Technologies',
    publishDate: '2025-01-05',
    readTime: '6 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/b7c7fd0e3e1392a2285249164a8dbdbb0010dcc289d8cf17785c807d41753619.jpeg',
    excerpt: 'FSSAI registration is the first step to starting a water bottling business. Learn about different license types, documentation, and the complete registration process.',
    featured: false
  },
  {
    id: 'licenses-required',
    slug: 'licences-required-mineral-water-bottling-plant',
    title: 'Licences Required for Mineral Water Bottling Plant',
    metaTitle: 'All Licenses Required for Mineral Water Plant in India 2025',
    metaDescription: 'Complete list of licenses and approvals required for starting a mineral water bottling plant in India. BIS, FSSAI, Pollution Board, Trade License, and more.',
    category: 'Compliance',
    author: 'Alden Technologies',
    publishDate: '2025-01-03',
    readTime: '9 min read',
    image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f',
    excerpt: 'Starting a water bottling plant requires multiple licenses. Complete checklist of all mandatory approvals from FSSAI, BIS, Pollution Board, and other authorities.',
    featured: true
  },
  {
    id: 'water-filling-machine-guide',
    slug: 'water-filling-machine-buying-guide',
    title: 'Water Filling Machine Buying Guide',
    metaTitle: 'Water Filling Machine Buying Guide 2025 | Choose the Right BPM Capacity',
    metaDescription: 'Complete buying guide for water filling machines. Compare 30 BPM to 200 BPM capacities, semi-automatic vs automatic, and choose the right machine for your plant.',
    category: 'Equipment Guide',
    author: 'Alden Technologies',
    publishDate: '2025-01-01',
    readTime: '8 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg',
    excerpt: 'Choosing the right water filling machine is critical for plant efficiency. Compare different BPM capacities, automation levels, and features to make an informed decision.',
    featured: false
  },
  {
    id: 'ro-plant-selection',
    slug: 'ro-plant-selection-guide',
    title: 'RO Plant Selection Guide',
    metaTitle: 'RO Plant Selection Guide | Choose Right LPH Capacity for Your Business',
    metaDescription: 'How to select the right RO plant capacity (LPH) for your water bottling business. Compare 2000 to 10000 LPH plants with features and specifications.',
    category: 'Equipment Guide',
    author: 'Alden Technologies',
    publishDate: '2024-12-28',
    readTime: '7 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/c0252d8d1c66f7574fc972f359f7fc489c0929e53c862e004029bb5dd7e5e832.jpeg',
    excerpt: 'RO plant capacity directly impacts your production capability. Learn how to calculate required LPH capacity and choose the right specifications for your business.',
    featured: false
  },
  {
    id: 'pet-bottle-blowing-guide',
    slug: 'pet-bottle-blowing-machine-guide',
    title: 'PET Bottle Blowing Machine Guide',
    metaTitle: 'PET Bottle Blowing Machine Guide | In-house Bottle Manufacturing',
    metaDescription: 'Complete guide on PET bottle blowing machines for in-house bottle production. Understand semi-auto vs fully-auto, capacity, investment, and ROI.',
    category: 'Equipment Guide',
    author: 'Alden Technologies',
    publishDate: '2024-12-25',
    readTime: '6 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/57f529b3089387bd7073555b73c6090bd4ab619173190c8346f2f661b66d40a2.jpeg',
    excerpt: 'Manufacturing bottles in-house reduces costs and gives flexibility. Learn about PET bottle blowing machines, capacity, investment, and profitability.',
    featured: false
  },
  {
    id: 'turnkey-plant-guide',
    slug: 'complete-turnkey-mineral-water-plant-setup-guide',
    title: 'Complete Turnkey Mineral Water Plant Setup Guide',
    metaTitle: 'Turnkey Mineral Water Plant Setup Guide 2025 | End-to-End Process',
    metaDescription: 'Complete turnkey plant setup guide from land selection to commissioning. Know the step-by-step process, timeline, and investment for complete water bottling plants.',
    category: 'Setup Guide',
    author: 'Alden Technologies',
    publishDate: '2024-12-20',
    readTime: '10 min read',
    image: 'https://images.unsplash.com/photo-1530037335614-e68828dcf258',
    excerpt: 'Turnkey solutions simplify plant setup with single-point responsibility. Understand the complete process, timeline, and what to expect from a turnkey project partner.',
    featured: true
  },
  {
    id: 'business-profit-roi',
    slug: 'mineral-water-business-profit-roi-guide',
    title: 'Mineral Water Business Profit & ROI Guide',
    metaTitle: 'Mineral Water Business Profit Margins & ROI in India 2025',
    metaDescription: 'Detailed profitability analysis of mineral water business in India. Know profit margins, ROI timeline, break-even analysis, and revenue projections.',
    category: 'Business Guide',
    author: 'Alden Technologies',
    publishDate: '2024-12-15',
    readTime: '9 min read',
    image: 'https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/b7c7fd0e3e1392a2285249164a8dbdbb0010dcc289d8cf17785c807d41753619.jpeg',
    excerpt: 'Is mineral water business profitable? Analyze profit margins, operational costs, revenue models, and realistic ROI timelines for different plant capacities.',
    featured: false
  }
];

// ========================================
// LEGACY DATA (Preserved for Backward Compatibility)
// ========================================

export const projects = [
  {
    id: 13,
    title: "24 BPM Mineral Water Plant - Rajasthan",
    client: "Aravalli Aqua Industries",
    technology: "2000 LPH RO + UV + Ozonation, 24 BPM Automatic Rinsing-Filling-Capping Machine",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "24 BPM (1,440 Bottles Per Hour)",
    location: "Jaipur, Rajasthan",
    year: "2025",
    description: "Complete 24 BPM turnkey mineral water plant for a first-time entrepreneur. Includes 2000 LPH RO plant with ozonation, automatic 24 BPM rinsing-filling-capping machine, sticker labelling, shrink packaging, and full BIS documentation support. Plant commissioned in 38 days from delivery.",
    image: "https://images.unsplash.com/photo-1605673393926-d95a8995e3de",
    category: "mineral-water"
  },
  {
    id: 14,
    title: "40 BPM Mineral Water Plant - Assam",
    client: "Brahmaputra Beverages",
    technology: "3000 LPH RO Plant, 40 BPM Automatic Filling Line, 2-Cavity PET Bottle Blowing",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "40 BPM (2,400 Bottles Per Hour)",
    location: "Guwahati, Assam",
    year: "2025",
    description: "Turnkey 40 BPM packaged drinking water project with in-house PET bottle blowing, 3000 LPH RO treatment, and automatic filling line. Designed for regional distribution across North-East India with BIS 14543 compliance.",
    image: "https://images.unsplash.com/photo-1530037335614-e68828dcf258",
    category: "mineral-water"
  },
  {
    id: 15,
    title: "60 BPM Packaged Drinking Water Plant - Bihar",
    client: "Ganga Neer Beverages",
    technology: "5000 LPH RO Plant, 60 BPM Rotary Filling Machine, Rotary Labelling, Shrink Packaging",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Under Installation",
    capacity: "60 BPM (3,600 Bottles Per Hour)",
    location: "Patna, Bihar",
    year: "2025",
    description: "Ongoing 60 BPM commercial-scale water bottling project featuring a 5000 LPH RO plant, 60 BPM rotary rinsing-filling-capping machine, automatic rotary sticker labelling, and shrink wrapping line. Commissioning scheduled shortly.",
    image: "https://static.prod-images.emergentagent.com/jobs/932fe87d-11cd-44ee-9b8b-ca40c329d944/images/52870b21522d31e2f71037c6540604e73ca73f4f5ad0415bdddaa4945a301960.jpeg",
    category: "mineral-water"
  },
  {
    id: 1,
    title: "Mineral Water Plant - Maharashtra",
    client: "Pure Drops Beverages Pvt Ltd",
    technology: "RO + UV + Ozonation, Rotary Filling Line, PLC Automation",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "6000 BPH (Bottles Per Hour)",
    location: "Pune, Maharashtra",
    year: "2024",
    description: "Complete turnkey mineral water plant with RO system, UV treatment, ozonation, and automatic bottle filling line. BIS certified facility.",
    image: "https://images.unsplash.com/photo-1530037335614-e68828dcf258",
    category: "mineral-water"
  },
  {
    id: 2,
    title: "Mango Juice Processing Plant",
    client: "FreshFruit Industries",
    technology: "Pulp Extraction, Pasteurization, Aseptic Packaging",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "3000 LPH (Liters Per Hour)",
    location: "Gujarat",
    year: "2023",
    description: "Advanced fruit juice processing plant with pulp extraction, pasteurization, and aseptic packaging system for extended shelf life.",
    image: "https://img.freepik.com/free-photo/worker-checking-bottles-juice-factory_107420-96528.jpg",
    category: "juice"
  },
  {
    id: 3,
    title: "Carbonated Soft Drink Plant",
    client: "Sparkle Beverages Ltd",
    technology: "Carbonation System, High-Speed CSD Filling Line",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "8000 BPH",
    location: "Delhi NCR",
    year: "2024",
    description: "Complete CSD plant with syrup preparation, carbonation system, high-speed filling line, and automated packaging solution.",
    image: "https://images.unsplash.com/photo-1648142375707-03918153f53e",
    category: "soft-drink"
  },
  {
    id: 4,
    title: "Packaged Drinking Water - Tamil Nadu",
    client: "AquaPure Solutions",
    technology: "Multi-Stage Filtration, Automatic Filling-Capping-Labelling",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "4500 BPH",
    location: "Chennai, Tamil Nadu",
    year: "2023",
    description: "Fully automatic packaged drinking water plant with multi-stage filtration, filling, capping, and labeling system.",
    image: "https://images.unsplash.com/photo-1605673393926-d95a8995e3de",
    category: "mineral-water"
  },
  {
    id: 5,
    title: "Orange Juice Plant - Karnataka",
    client: "Citrus Fresh Pvt Ltd",
    technology: "Juice Extraction, Pasteurization, PET Hot Filling",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "2500 LPH",
    location: "Bangalore, Karnataka",
    year: "2023",
    description: "RTS juice processing plant with extraction, filtration, pasteurization, and PET bottle filling line.",
    image: "https://img.freepik.com/premium-photo/stateoftheart-fruit-juice-extraction-line_1324785-4183.jpg",
    category: "juice"
  },
  {
    id: 6,
    title: "Soda Manufacturing Unit",
    client: "Fizz Drinks Co",
    technology: "CO2 Injection, Crown Corking, Packaging Automation",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "5000 BPH",
    location: "Rajasthan",
    year: "2024",
    description: "Complete soda and carbonated water plant with CO2 injection, filling, crown corking, and packaging automation.",
    image: "https://images.unsplash.com/photo-1774887810190-5de1cc9cb06e",
    category: "soft-drink"
  },
  {
    id: 7,
    title: "Mineral Water Bottling Plant - Haryana",
    client: "Crystal Waters India",
    technology: "Dual RO Trains, 120 BPM High-Speed Filling, Auto Packaging",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "10000 BPH",
    location: "Gurgaon, Haryana",
    year: "2024",
    description: "Large-scale mineral water bottling plant with advanced RO purification, automated filling, and high-speed packaging line. Complete BIS & FSSAI compliance.",
    image: "https://images.unsplash.com/photo-1530037335614-e68828dcf258",
    category: "mineral-water"
  },
  {
    id: 8,
    title: "Mixed Fruit Juice Plant - Uttar Pradesh",
    client: "Natural Nectar Beverages",
    technology: "Multi-Fruit Extraction Lines, Hot Filling, Cold Storage",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "4000 LPH",
    location: "Noida, Uttar Pradesh",
    year: "2023",
    description: "Multi-fruit juice processing facility with separate extraction lines for mango, orange, and apple. Includes hot filling and cold storage systems.",
    image: "https://img.freepik.com/free-photo/worker-checking-bottles-juice-factory_107420-96528.jpg",
    category: "juice"
  },
  {
    id: 9,
    title: "Packaged Drinking Water - Madhya Pradesh",
    client: "Jal Shakti Enterprises",
    technology: "6-Stage Purification, UV Sterilization, Semi-Auto Filling",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "3000 BPH",
    location: "Indore, Madhya Pradesh",
    year: "2024",
    description: "Turnkey packaged drinking water plant with 6-stage purification, UV sterilization, and semi-automatic filling system.",
    image: "https://images.unsplash.com/photo-1605673393926-d95a8995e3de",
    category: "mineral-water"
  },
  {
    id: 10,
    title: "Energy Drink Manufacturing Plant",
    client: "Power Boost India",
    technology: "Carbonation, Vitamin Dosing, Can Filling Line",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "6000 BPH",
    location: "Hyderabad, Telangana",
    year: "2023",
    description: "Specialized energy drink production line with carbonation, vitamin injection system, and can filling capabilities.",
    image: "https://images.unsplash.com/photo-1648142375707-03918153f53e",
    category: "soft-drink"
  },
  {
    id: 11,
    title: "Mineral Water Bottling Plant - West Bengal",
    client: "Ganga Fresh Waters",
    technology: "Dual RO + Ozonation, Fully Automatic PET Line",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "8000 BPH",
    location: "Kolkata, West Bengal",
    year: "2024",
    description: "State-of-the-art mineral water bottling facility with dual RO systems, ozonation, and fully automated PET bottle production line.",
    image: "https://images.unsplash.com/photo-1763264296091-c894c0b0a122",
    category: "mineral-water"
  },
  {
    id: 12,
    title: "Coconut Water Processing Plant",
    client: "Tropical Refresh Co",
    technology: "Cold Processing Technology, Aseptic Bottling",
    scope: "Complete Turnkey Project — design, machinery, installation & commissioning",
    status: "Commissioned & Running",
    capacity: "2000 LPH",
    location: "Kerala",
    year: "2023",
    description: "Specialized coconut water extraction and bottling plant with cold processing technology to retain nutrients and natural flavor.",
    image: "https://img.freepik.com/premium-photo/stateoftheart-fruit-juice-extraction-line_1324785-4183.jpg",
    category: "juice"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Rajesh Kumar",
    company: "Pure Drops Beverages Pvt Ltd",
    designation: "Managing Director",
    content: "Alden Technologies delivered our 6000 BPH mineral water plant ahead of schedule. Their technical expertise and after-sales support have been exceptional. Highly recommended for turnkey beverage projects.",
    rating: 5,
    image: "https://ui-avatars.com/api/?name=Rajesh+Kumar&background=0B6B3A&color=fff"
  },
  {
    id: 2,
    name: "Priya Sharma",
    company: "FreshFruit Industries",
    designation: "Production Head",
    content: "The juice processing plant installed by Alden Technologies has been running flawlessly for over a year. Their complete project management approach made the entire process hassle-free.",
    rating: 5,
    image: "https://ui-avatars.com/api/?name=Priya+Sharma&background=0B6B3A&color=fff"
  },
  {
    id: 3,
    name: "Amit Patel",
    company: "Sparkle Beverages Ltd",
    designation: "CEO",
    content: "We chose Alden Technologies for our CSD plant, and it was the best decision. From design to commissioning, everything was professionally handled. The plant efficiency exceeds our expectations.",
    rating: 5,
    image: "https://ui-avatars.com/api/?name=Amit+Patel&background=0B6B3A&color=fff"
  },
  {
    id: 4,
    name: "Meena Iyer",
    company: "AquaPure Solutions",
    designation: "Operations Manager",
    content: "Excellent service and quality equipment. The Alden team provided comprehensive training to our staff and continues to provide prompt support whenever needed.",
    rating: 5,
    image: "https://ui-avatars.com/api/?name=Meena+Iyer&background=0B6B3A&color=fff"
  }
];

export const products = [
  {
    id: 1,
    title: "Mineral Water Plant",
    slug: "mineral-water-plant",
    shortDesc: "Complete turnkey solutions for packaged drinking water and mineral water plants with advanced purification systems.",
    image: "https://images.unsplash.com/photo-1530037335614-e68828dcf258",
    features: [
      "Multi-stage RO purification system",
      "UV and Ozone treatment",
      "Automatic bottle rinsing, filling & capping",
      "Capacity: 1000 to 12000 BPH",
      "PLC-based automation",
      "BIS & FSSAI compliance support"
    ],
    applications: [
      "Packaged Drinking Water",
      "Mineral Water Production",
      "Bulk Water Supply",
      "Commercial Bottling"
    ],
    capacity: "1000 - 12000 BPH"
  },
  {
    id: 2,
    title: "Soft Drink Plant",
    slug: "soft-drink-plant",
    shortDesc: "Advanced carbonated soft drink manufacturing plants with syrup preparation, carbonation, and high-speed filling systems.",
    image: "https://images.unsplash.com/photo-1648142375707-03918153f53e",
    features: [
      "Syrup preparation & mixing system",
      "CO2 carbonation technology",
      "High-speed filling & capping line",
      "Capacity: 2000 to 10000 BPH",
      "Automated quality control",
      "Energy-efficient operations"
    ],
    applications: [
      "Carbonated Soft Drinks",
      "Soda Water Production",
      "Energy Drinks",
      "Flavored Beverages"
    ],
    capacity: "2000 - 10000 BPH"
  },
  {
    id: 3,
    title: "Juice Processing Plant",
    slug: "juice-processing-plant",
    shortDesc: "Complete fruit juice and pulp processing plants with extraction, pasteurization, and aseptic packaging solutions.",
    image: "https://img.freepik.com/free-photo/worker-checking-bottles-juice-factory_107420-96528.jpg",
    features: [
      "Fruit washing & sorting system",
      "Pulp extraction & filtration",
      "Pasteurization & homogenization",
      "Capacity: 1000 to 5000 LPH",
      "Aseptic packaging option",
      "Cold chain preservation"
    ],
    applications: [
      "Mango, Orange, Apple Juice",
      "Mixed Fruit Beverages",
      "RTS (Ready-to-Serve) Drinks",
      "Fruit Pulp Processing"
    ],
    capacity: "1000 - 5000 LPH"
  }
];

export const faqs = [
  {
    question: "What is the cost of setting up a mineral water plant?",
    answer: "The cost varies based on capacity and automation level. A basic 1000 BPH plant starts from ₹25-30 lakhs, while a fully automatic 6000 BPH plant can cost ₹80 lakhs to 1.5 crores. Contact us for a detailed quotation based on your specific requirements."
  },
  {
    question: "How long does it take to install a complete beverage plant?",
    answer: "Typically, a turnkey beverage plant installation takes 3-6 months depending on capacity and complexity. This includes design approval, manufacturing, installation, testing, and commissioning. We ensure minimal delays through efficient project management."
  },
  {
    question: "What licenses are required to start a beverage manufacturing business?",
    answer: "You'll need: 1) FSSAI license for food safety, 2) BIS certification for packaged drinking water, 3) Pollution Control Board clearance, 4) Trade license from local authority, 5) GST registration. We provide complete compliance support and documentation assistance."
  },
  {
    question: "Do you provide training and after-sales support?",
    answer: "Yes, we provide comprehensive operator training for plant operations and maintenance. Our after-sales support includes 1-year warranty, spare parts supply, AMC options, and 24/7 technical assistance to ensure smooth plant operations."
  },
  {
    question: "Can you customize the plant according to our production needs?",
    answer: "Absolutely! We specialize in customized turnkey solutions. Our engineering team designs plants based on your capacity requirements, available space, budget, and specific product formulations. Every project is tailored to client needs."
  },
  {
    question: "What is the difference between RO and mineral water?",
    answer: "RO (Reverse Osmosis) water is purified water where minerals are removed through filtration. Mineral water has naturally occurring minerals or minerals are added back after purification. Both require proper treatment and BIS certification for commercial bottling."
  }
];

export const services = [
  {
    id: "turnkey",
    title: "Turnkey Project Execution",
    description: "Complete end-to-end project management from concept to commissioning with single-point responsibility.",
    icon: "package"
  },
  {
    id: "design",
    title: "Plant Design & Engineering",
    description: "Customized plant layout and design based on your space, capacity, and production requirements.",
    icon: "ruler"
  },
  {
    id: "installation",
    title: "Installation & Commissioning",
    description: "Professional installation by experienced technicians with thorough testing and quality checks.",
    icon: "wrench"
  },
  {
    id: "automation",
    title: "Automation Solutions",
    description: "PLC-based automation systems for efficient operations and reduced manual intervention.",
    icon: "cpu"
  },
  {
    id: "training",
    title: "Training & Support",
    description: "Comprehensive operator training and 24/7 technical support for smooth plant operations.",
    icon: "headphones"
  },
  {
    id: "compliance",
    title: "Compliance Assistance",
    description: "Complete support for BIS, FSSAI, and regulatory compliance documentation.",
    icon: "checkCircle"
  }
];
